<template>
  <div
    class="modal fade p-0"
    tabindex="-1"
    aria-labelledby="alertModal"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    ref="alertModalRef"
  >
    <div class="modal-dialog modal-dialog-centered" :class="modalSize">
      <div class="modal-content">
        <div class="modal-header p-2" :class="modalBgColor + ' ' + titleColor">
          <h4 class="m-0">{{ alertTitel }}</h4>
        </div>

        <div class="modal-body">
          <p>{{ alertMessage }}</p>
        </div>

        <div class="modal-footer p-1">
          <button class="btn btn-secondary" @click="cancel()">Abbrechen</button>
          <button class="btn" :class="modalButtonColor" @click="confirm()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue';
  import { Modal } from 'bootstrap';

  // const emit = defineEmits<{
  //   (e: 'confirm'): void;
  //   (e: 'cancel'): void;
  // }>();

  const emit = defineEmits(['confirm', 'cancel']);

  const modalSize = ref('');

  const modalColor = ref('primary');
  const modalBgColor = computed(() => `bg-${modalColor.value}`);
  const modalButtonColor = computed(() => `btn-${modalColor.value}`);

  const titleColor = ref('text-white');

  const alertTitel = ref('');
  const alertMessage = ref('');

  const confirmParam = ref('');
  const cancelParam = ref('');

  const alertModalRef = ref(false);

  function hideAlert() {
    Modal.getInstance(alertModalRef.value)?.hide();
  }

  function showAlert(
    title: string,
    message: string,
    confirmMsg: string = '',
    cancelData: string = '',
    color: string = 'bg-danger',
    titleTextColor: string = 'text-white',
    size: string = ''
  ) {
    modalSize.value = size;
    modalColor.value = color;
    titleColor.value = titleTextColor;
    alertTitel.value = title;
    alertMessage.value = message;
    confirmParam.value = confirmMsg;
    cancelParam.value = cancelData;

    if (alertModalRef.value) {
      new Modal(alertModalRef.value).show();
    }
  }

  function cancel() {
    emit('cancel', cancelParam.value);
    hideAlert();
  }

  function confirm() {
    emit('confirm', confirmParam.value);
    hideAlert();
  }

  defineExpose({
    showAlert,
  });
</script>

<style scoped>
  .simple-notification {
    position: absolute;
    top: 12.5%;
    left: 12.5%;
    z-index: 1000;
  }

  .simple-notification-message {
    font-size: 5em;
    font-weight: bold;
  }
</style>
